import { Action } from 'redux';

/**
 * Action type constants for Data Export
 */
export const DATA_EXPORT_START = 'DATA_EXPORT_START';
export const DATA_EXPORT_SUCCESS = 'DATA_EXPORT_SUCCESS';
export const DATA_EXPORT_ERROR = 'DATA_EXPORT_ERROR';
export const DATA_EXPORT_RESET = 'DATA_EXPORT_RESET';

/**
 * Action interfaces
 */
type DataExportStartAction = Action<typeof DATA_EXPORT_START>;

type DataExportSuccessAction = Action<typeof DATA_EXPORT_SUCCESS>;

interface DataExportErrorAction extends Action<typeof DATA_EXPORT_ERROR> {
    payload: {
        error: string;
    };
}

type DataExportResetAction = Action<typeof DATA_EXPORT_RESET>;

/**
 * Union type for all Data Export actions
 */
export type DataExportAction =
    | DataExportStartAction
    | DataExportSuccessAction
    | DataExportErrorAction
    | DataExportResetAction;
